export default __webpack_public_path__ + "assets/images/38023b115aff06368a6b8b8a3186645d.png";